<template>
  <div class="flex flex-col gap-4 bg-white min-h-48 p-4 shadow-md">
    <div
      class="flex flex-col gap-4 sm:flex-row sm:items-center md:justify-between"
    >
      <div v-if="!despacho" class="text-left font-bold text-xl text-blue">
        {{ title }}
      </div>

      <div v-else class="font-bold text-xl text-blue">
        {{ title + despacho.codigo }} - {{ despacho.cliente?.nombre ?? "-" }}
      </div>

      <div
        v-if="canManage()"
        class="flex flex-row flex-wrap items-center gap-2"
      >
        <button
          type="button"
          v-if="tercerBoton"
          class="btn-secundario"
          @click="terceraAccionBoton"
        >
          {{ tercerText }}
        </button>
        <button
          type="button"
          v-if="segundoboton"
          class="btn-secundario "
          @click="segundoaccionBoton"
        >
          {{ segundotext }}
        </button>
        <button
          type="button"
          v-permisos="permiso"
          v-if="boton"
          class="btn-principal"
          @click="accionBoton"
        >
          {{ text }}
        </button>
        <slot name="extraButtons"></slot>
      </div>
    </div>
    
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    title: String,
    accionBoton: Function,
    boton: Boolean,
    text: String,
    permiso: String,
    despacho: Object,
    segundoaccionBoton: Function,
    segundoboton: Boolean,
    segundotext: String,
    terceraAccionBoton: Function,
    tercerText: String,
    tercerBoton: Boolean,
    canManage: {
      type: Function,
      default: () => {
        return true;
      },
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
